import { render, staticRenderFns } from "./cdl.vue?vue&type=template&id=ea20c37a&scoped=true"
import script from "./cdl.vue?vue&type=script&lang=js"
export * from "./cdl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea20c37a",
  null
  
)

export default component.exports